module.exports = __webpack_public_path__ + "img/IconClose.14a562bb.svg";